import { render, staticRenderFns } from "./estudianteCurso.vue?vue&type=template&id=43c369dc"
import script from "./estudianteCurso.vue?vue&type=script&lang=js"
export * from "./estudianteCurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports